/** sessionStorage key a redirect document stores its own referrer under before it navigates on. */
export const HOP_REFERRER_KEY = 'fi_hop_referrer';

/**
 * The referrer a page view should report when this page was reached through a redirect document: the
 * site that linked to the redirect, not the redirect itself. Read once, and only while
 * document.referrer is still the redirect that stored it.
 */
export function takeHopReferrer() {
  try {
    const stored = sessionStorage.getItem(HOP_REFERRER_KEY);
    sessionStorage.removeItem(HOP_REFERRER_KEY);
    const hop = stored ? (JSON.parse(stored) as { from: string; referrer: string }) : undefined;
    // the redirect stores its location.href, and document.referrer never carries the fragment
    return hop?.from.split('#')[0] === document.referrer ? hop.referrer : undefined;
  } catch {
    return undefined;
  }
}
